var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8879.4999c2.22768 0 4.0467 1.75087 4.1549 3.95142l.0051.20758v.456h8.728v1h-1.844l.0006 18.3178c0 2.78128-2.21412 5.06704-4.96846 5.18243l-.21854.00457H9.0305c-2.78096 0-5.06702-2.21476-5.18243-4.9685l-.00457-.2185-.0006-18.3178h-1.843v-1h8.729v-.456c0-2.29714 1.86186-4.159 4.159-4.159zM24.932 6.186H4.843l.0005 18.2467c0 2.16235 1.66356 3.95697 3.7734 4.16655l.20553.0153.20807.00515h11.715c2.23272 0 4.0724-1.77228 4.18185-3.9789l.00515-.2081L24.932 6.186zm-13.0591 7.2139v7.029h-1v-7.029h1zm7.03 0v7.029h-1v-7.029h1zm-4.015-11.9c-1.68469 0-3.06108 1.3183-3.154 2.97972l-.005.17928v.456h6.319v-.456c0-1.74462-1.4149-3.159-3.16-3.159z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.45c185b4.svg";
export { ForwardRef as ReactComponent };